export const POST = "POST";
export const PUT = "PUT";
export const GET = "GET";

export const FHIR_METHODS = [
  { TYPE: POST, RESOURCE: "createResource" },
  { TYPE: PUT, RESOURCE: "updateResource" },
];

// FHIR Location.type for clinical-trial sites. Mirrors samaras-ctms-service's
// site → FHIR Location transformer (adapters/{sitecentric,realtime}/transformers/site.js)
// so sites created from the frontend match CTMS-synced ones and are found by
// the same search filter.
export const SITE_LOCATION_TYPE_SYSTEM = "http://enliv.com/ctms/location-type";
export const SITE_LOCATION_TYPE_CODE = "clinical-trial-site";
export const SITE_LOCATION_TYPE_DISPLAY = "Clinical Trial Site";

export const SITE_LOCATION_TYPE = [
  {
    coding: [
      {
        system: SITE_LOCATION_TYPE_SYSTEM,
        code: SITE_LOCATION_TYPE_CODE,
        display: SITE_LOCATION_TYPE_DISPLAY,
      },
    ],
    text: SITE_LOCATION_TYPE_DISPLAY,
  },
];

export const SUBJECT_POOL_TAG_SYSTEM =
  "http://enliv.com/fhir/coding/subject-pool";

// Meta-tag marking a Group's origin. Lead-generation "Ad Leads" pools created
// during campaign launch carry group-source=lead-generation; used to exclude
// them from the subject-pool pickers.
export const GROUP_SOURCE_TAG_SYSTEM =
  "http://enliv.com/fhir/coding/group-source";
export const LEAD_GENERATION_GROUP_SOURCE_TAG = "lead-generation";

// CTMS patient-identifier systems written back onto the FHIR Patient after a
// successful CTMS push. Presence of either marks the patient as "pushed to CTMS".
export const SITECENTRIC_PATIENT_IDENTIFIER_SYSTEM =
  "http://enliv.com/sitecentric/patient-id";
export const CTMS_EXTERNAL_ID_SYSTEM =
  "http://enliv.com/integration/ctms/external-id";
